import React from 'react'
import { connect } from 'react-redux'
import { useRouter } from 'next/router'
import { getVehicleParts } from 'SRC/modules/vehicleParts/list/selectors'
import { getPagination } from 'SRC/modules/vehicleParts/list/selectors'
import { getUrlValues } from 'SRC/modules/vehicleParts/utils/vehiclePartsUtils'
import { Links } from 'SRC/modules/common/components/Pagination'
import PropTypes from 'prop-types'

import useTranslation from 'next-translate/useTranslation'

import translations from '../../../../../../public/data/translations.json'

const VehiclePartsSearch = ({ paginationParams, products }) => {
  const router = useRouter()

  const { lang } = useTranslation('common')

  const locale = lang?.toUpperCase() || 'ME'

  if (paginationParams?.totalPages <= 1) return null

  const urlValues = getUrlValues(router.query)

  console.log('urlValues', urlValues)

  const { page, ...restFilterValues } = urlValues

  const textFilter = router?.query?.['text-filter']

  const pageCount = Number(paginationParams.totalPages)
  if (pageCount === 0) return null

  const currentPage = Number(paginationParams.page)
  const isFirstPage = currentPage === 1
  const isLastPage = currentPage === pageCount
  const baseUrl = {
    href: { pathname: '/vehiclePartsSearch', query: {} },
    as: `/${translations.noviDjeloviUrl[locale]}/${translations['auto-djelovi'][locale].gume.slug}/${translations.pretraga[locale]}`
  }

  if (Object.keys(restFilterValues).length) {
    baseUrl.href.query = restFilterValues
  }

  if (textFilter) baseUrl.href.query['text-filter'] = textFilter

  const buildAsUrl = (pageNumber) => {
    return `${baseUrl.as}?${new URLSearchParams({
      ...(textFilter ? { 'text-filter': textFilter } : {}),
      page: String(pageNumber),
      ...restFilterValues
    }).toString()}`
  }

  const prevPageNumber = currentPage === 1 ? currentPage : currentPage - 1
  const prevUrl = {
    href: {
      pathname: baseUrl.href.pathname,
      query: {
        ...baseUrl.href.query,
        page: prevPageNumber
      }
    },
    as: buildAsUrl(prevPageNumber)
  }

  const nextPageNumber = currentPage === pageCount ? currentPage : currentPage + 1
  const nextUrl = {
    href: {
      pathname: baseUrl.href.pathname,
      query: {
        ...baseUrl.href.query,
        page: nextPageNumber
      }
    },
    as: buildAsUrl(nextPageNumber)
  }

  const pages = []

  for (let i = 1; i <= pageCount; i++) {
    pages.push({
      number: i,
      isCurrent: i === currentPage,
      href: {
        pathname: baseUrl.href.pathname,
        query: {
          ...baseUrl.href.query,
          page: i
        }
      },
      as: buildAsUrl(i)
    })
  }

  if (!products?.length) return null

  return (
    <div className='vehicle-parts-pagination'>
      <Links
        isFirstPage={isFirstPage}
        isLastPage={isLastPage}
        prevUrl={prevUrl}
        nextUrl={nextUrl}
        pages={[...pages]}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  products: getVehicleParts(state),
  paginationParams: getPagination(state)
})

VehiclePartsSearch.propTypes = {
  products: PropTypes.array.isRequired,
  paginationParams: PropTypes.shape({
    page: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
  }).isRequired
}

VehiclePartsSearch.defaultProps = {
  products: []
}

export default connect(mapStateToProps)(VehiclePartsSearch)
